import Cookies from 'js-cookie';
import { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router';

const affiliateIdQueryParam = 'affiliateId';
const affiliateSourceQueryParam = 'affiliateSource';

type AffiliateData = {
  id?: string;
  source?: string;
};

export const useGetAffiliateDataFromUrlOrCookie = ():
  | AffiliateData
  | undefined => {
  const location = useLocation();
  const [affiliateData, setAffiliateData] = useState<
    AffiliateData | undefined
  >();

  const getAffiliateData = useCallback((): AffiliateData => {
    const query = new URLSearchParams(location.search);
    const token = query.get(affiliateIdQueryParam);
    const affiliateSource = query.get(affiliateSourceQueryParam);

    if (affiliateSource) {
      query.delete(affiliateSourceQueryParam);
      Cookies.set(affiliateSourceQueryParam, affiliateSource, { expires: 15 });
    }

    if (token) {
      query.delete(affiliateIdQueryParam);
      Cookies.set(affiliateIdQueryParam, token, { expires: 15 });

      return { id: token, source: affiliateSource ?? undefined };
    }

    return {
      id: Cookies.get(affiliateIdQueryParam),
      source: Cookies.get(affiliateSourceQueryParam) ?? undefined,
    };
  }, [location]);

  useEffect(() => {
    const data = getAffiliateData();

    if (data) {
      setAffiliateData({
        id: data.id,
        source: data.source,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return affiliateData;
};
